export default __webpack_public_path__ + "static/media/Saly-22.07e4bf1e.svg";